export const FETCH_PAYMENT_DATA_LOADING = "FETCH_PAYMENT_DATA_LOADING";
export const FETCH_PAYMENT_DATA = "FETCH_PAYMENT_DATA";
export const FETCH_PAYMENT_DATA_ERROR = "FETCH_PAYMENT_DATA_ERROR";
export const ADD_CARD_LOADING = "ADD_CARD_LOADING";
